import * as React from 'react';
import ContentBox from './ContentBox';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import FilterListIcon from '@mui/icons-material/FilterList';

import CountryListSingle from './CountryListSingle';
import { Button } from '@mui/material';

export default function CountryList(props) {
  return (
    <TableContainer>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell sx={{width: '45%', paddingRight: 0}}><Typography variant="body1">Name</Typography></TableCell>
                    <TableCell sx={{width: '45%', paddingRight: 0}}><Typography variant="body1">Region</Typography></TableCell>
                    <TableCell sx={{width: '10%', paddingRight: 0}}>{props.filter && <Button onClick={props.filter} variant="text" endIcon={<FilterListIcon />}>Search</Button>}</TableCell>
                </TableRow>
            </TableHead>
        </Table>
        <ContentBox sx={{p: 0}}>
            <Table>
                <TableBody>
                    { ( props.data && ( props.data.length > 0 ) ) ?
                        props.data.map((row) => {
                            var countrySingleProps = {
                                key: row.getId(),
                                data: row
                            };

                            if( props.onDelete )
                            {
                                countrySingleProps['onDelete'] = props.onDelete;
                            }

                            if( props.onCopy )
                            {
                                countrySingleProps['onCopy'] = props.onCopy;
                            }

                            return (
                                <CountryListSingle {...countrySingleProps} />
                            )
                        }
                    )
                    :
                    <TableRow>
                        <TableCell colSpan={7} sx={{width: '40%', paddingRight: 0, textAlign: 'center'}} component="th" scope="row">
                            <Typography variant="body1">{props.noRecordsLabel || 'No results to display'}</Typography>
                        </TableCell>
                    </TableRow>
                    }
                </TableBody>
            </Table>
        </ContentBox>
    </TableContainer>
  );
}